import React, { Component, PropTypes } from 'react';
import CSSModules from 'react-css-modules';
import style from './style.css';


const Title = (props) => {
    return(
        <div styleName="container" className={props.className}>
            {props.children}
            { props.icon &&
                <img src={`${process.env.PUBLIC_URL}/${props.icon}.png`}/>
            }
        </div>
    );
}

export default CSSModules(Title,style,{allowMultiple:true});


/** WEBPACK FOOTER **
 ** ./src/component/title/index.js
 **/